import React, { useState, useEffect } from 'react';
import CreateForm from '../../components/Tasks/CreateForm';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import { Link, useNavigate, useParams } from 'react-router-dom';
import useApiManager from '../../utils/Api/apiManager';
import EditForm from '../../components/Tasks/EditForm';
import EntityTimeline from '../../components/Common/Timeline/Timeline';

const EditTask = () => {
    const [taskData, setTaskData] = useState(null);
    const [taskHistory, setTaskHistory] = useState([]); // If you have history data
    const [tabIndex, setTabIndex] = useState(0);
    const [loading, setLoading] = useState(true);

    const navigate = useNavigate();
    const { get, put } = useApiManager();
    const { taskId } = useParams();

    const fetchTaskData = async () => {
        try {
            const data = await get(`/tasks/${taskId}`);
            console.log(data);
            setTaskData(data);

            // Optional: if your task history is part of the same response or another endpoint:
            // const history = await get(`/tasks/${taskId}/history`);
            // setTaskHistory(history);

        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (taskId) {
            fetchTaskData();
        }
    }, [taskId]);

    const handleFormSubmit = async (formData) => {
        try {
            const responseData = await put(`/tasks/${taskId}`, formData);
            console.log('Form Submitted Successfully:', responseData);
            goBack();
        } catch (error) {
            console.error('Failed to submit form:', error);
        }
    };

    const goBack = () => {
        navigate(-1);
    };

    const handleTabChange = (event, newValue) => {
        setTabIndex(newValue);
    };

    useEffect(() => {
        document.title = "Edit Task - iLead CRM";
    }, []);

    return (
        <Box sx={{ p: 5 }}>
            <Paper elevation={3} sx={{ p: 2 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: 1 }}>
                    <Tabs value={tabIndex} onChange={handleTabChange}>
                        <Tab label="Edit Task" />
                        <Tab label="History" />
                    </Tabs>
                    <Box sx={{ display: 'flex', gap: 1 }}>
                        <Link to="/tasks">
                            <Button variant="outlined" onClick={goBack}>Cancel</Button>
                        </Link>
                        <Button variant="contained" type="submit" form="create-form">Save</Button>
                    </Box>
                </Box>
                <Divider aria-hidden="true" sx={{ borderWidth: "thin" }} />


                {tabIndex === 0 && (
                    <EditForm onSubmit={handleFormSubmit} taskData={taskData} />
                )}

                {tabIndex === 1 && (
                    <Box sx={{ mt: "10px", mx: 19 }}>
                        <h4>Task History</h4>
                        {/* <TaskTimeline history={taskHistory} /> */}
                        <EntityTimeline entityId={taskId} entityType={'tasks'} />
                    </Box>
                )}
            </Paper>
        </Box>
    );
};

export default EditTask;
